module.exports = __webpack_public_path__ + "img/arhiva.125dcfb4.png";